import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import MqttManager from "../../mqtt/Base";
import { UpdateEquipmentButton } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import { MqttContext } from "../../context/MQTTContext";

const LearnCodeModal = () => {
  const {
    setLearnCodeModal,
    buttonShouldLearnCode,
    setButtonShouldLearnCode,
    setUpdate,
    setWirelessKeyMode,
    wirelessKeyMode,
    update,
    setIsLoading,
    setEquipmentButtons,
    equipmentButtons,
    devices,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const modalName = useRef(null);
  const closeButton = useRef();
  const [learningMode, setLearningMode] = useState(false);
  const [lazyLoadForWirlessLearnCode, setLazyLoadForWirlessLearnCode] =
    useState(false);
  const [checkCode, setCheckCode] = useState(false);

  useEffect(() => {
    if (modalName.current) {
      // Ensure modalName is wrapped as a jQuery object
      const $modal = window.$(modalName.current);

      setLearnCodeModal(modalName);

      // Attach the event listener
      $modal.on("hidden.bs.modal", function (e) {
        setCheckCode(false);
        setLearningMode(false);
        setWirelessKeyMode(false);
        setLazyLoadForWirlessLearnCode(false);
        setButtonShouldLearnCode(null);
      });

      // Cleanup the event listener on component unmount
      return () => {
        $modal.off("hidden.bs.modal");
      };
    }
  }, []);

  useEffect(() => {
    if (learningMode) {
      let device = devices.find((d) => d.id == buttonShouldLearnCode.device_id);
      if (!device) {
        return;
      }
      let messageListener;
      if (device.is_bus == 1) {
        if (!clients[device.bridge_device.id]) return;
        // تعریف تابع برای لیسنر پیام‌ها
        messageListener = (topic, message, packet) => {
          if (learningMode) {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              message[10] == 1 &&
              message[2] == 14
            ) {
              let codeSize = message[11];
              let code = [
                codeSize,
                message[13],
                message[14],
                message[15],
                message[16],
                message[17],
              ];
              setIsLoading(true);
              UpdateEquipmentButton({
                equipment_button_id: buttonShouldLearnCode.id,
                name: buttonShouldLearnCode.name,
                digit: buttonShouldLearnCode.digit,
                icon: buttonShouldLearnCode.icon,
                data: [code[1], code[2], code[3], code[4], code[5]],
              }).then((res) => {
                if (closeButton.current) {
                  SuccessToast("با موفقیت یادگیری شد");
                  setEquipmentButtons(
                    equipmentButtons.map((eq_btn) =>
                      eq_btn.id == buttonShouldLearnCode.id
                        ? {
                            ...eq_btn,
                            data1: code[1],
                            data2: code[2],
                            data3: code[3],
                            data4: code[4],
                            data5: code[5],
                          }
                        : eq_btn,
                    ),
                  );
                  closeButton.current.click();
                  setLearningMode(false);
                  setUpdate(!update);
                  setIsLoading(false);
                }
              });
            }
          }
        };

        // ثبت لیسنر پیام‌ها
        clients[device.bridge_device.id].on("message", messageListener);

        let buffer = new ArrayBuffer(10);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 6;
        asciiCode[9] = wirelessKeyMode ? 2 : 1;
        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );

        if (wirelessKeyMode) {
          setLazyLoadForWirlessLearnCode(true);
          setTimeout(() => {
            setLazyLoadForWirlessLearnCode(false);
            setCheckCode(true);
          }, 5000);
        }
      } else {
        if (!clients[device.id]) return;
        // تعریف تابع برای لیسنر پیام‌ها
        messageListener = (topic, message, packet) => {
          if (learningMode) {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              message[2] == 1 &&
              message.length >= 5
            ) {
              let codeSize = message[3];
              let code = [message[3]];
              for (let i = 1; i <= codeSize; i++) {
                code.push(message[4 + i]);
              }
              setIsLoading(true);
              UpdateEquipmentButton({
                equipment_button_id: buttonShouldLearnCode.id,
                name: buttonShouldLearnCode.name,
                digit: buttonShouldLearnCode.digit,
                icon: buttonShouldLearnCode.icon,
                data: [code[1], code[2], code[3], code[4], code[5]],
              }).then((res) => {
                if (closeButton.current) {
                  SuccessToast("با موفقیت یادگیری شد");
                  setEquipmentButtons(
                    equipmentButtons.map((eq_btn) =>
                      eq_btn.id == buttonShouldLearnCode.id
                        ? {
                            ...eq_btn,
                            data1: code[1],
                            data2: code[2],
                            data3: code[3],
                            data4: code[4],
                            data5: code[5],
                          }
                        : eq_btn,
                    ),
                  );
                  closeButton.current.click();
                  setLearningMode(false);
                  setUpdate(!update);
                  setIsLoading(false);
                }
              });
            }
          }
        };

        // ثبت لیسنر پیام‌ها
        clients[device.id].on("message", messageListener);

        const decimalArray = wirelessKeyMode ? [6, 2] : [6, 1];
        const asciiArray = decimalArray.map((num) => String.fromCharCode(num));
        clients[device.id].publish(
          device.serial + "/sys",
          device.internet_token + asciiArray.join(""),
        );

        if (wirelessKeyMode) {
          setLazyLoadForWirlessLearnCode(true);
          setTimeout(() => {
            setLazyLoadForWirlessLearnCode(false);
            setCheckCode(true);
          }, 5000);
        }
      }

      // پاک‌سازی بعد از اتمام learningMode
      return () => {
        if (device.is_bus == 1) {
          clients[device.bridge_device.id].removeListener(
            "message",
            messageListener,
          );
        } else {
          clients[device.id].removeListener("message", messageListener);
        }
      };
    }
  }, [learningMode]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleCancleLearnCode = () => {
    let device = devices.find((d) => d.id == buttonShouldLearnCode.device_id);
    if (!device) {
      return;
    }
    if (device.is_bus == 1) {
      if (!clients[device.bridge_device.id]) return;
      let buffer = new ArrayBuffer(10);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = device.type + 50;
      asciiCode[8] = 6;
      asciiCode[9] = 7;
      let message = device.bridge_device.internet_token;

      // ترکیب رشته و بافر
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.bridge_device.id].publish(
        device.bridge_device.serial + "/sys",
        combinedMessage,
      );
    } else {
      if (!clients[device.id]) return;
      const decimalArray = [6, 7];
      const asciiArray = decimalArray.map((num) => String.fromCharCode(num));
      clients[device.id].publish(
        device.serial + "/sys",
        device.internet_token + asciiArray.join(""),
      );
    }
  };

  const handleSubmitLearnCodeInWirelessMode = () => {
    let device = devices.find((d) => d.id == buttonShouldLearnCode.device_id);
    if (!device) {
      return;
    }

    if (device.is_bus == 1) {
      if (!clients[device.bridge_device.id]) return;

      let buffer = new ArrayBuffer(10);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = device.type + 50;
      asciiCode[8] = 6;
      asciiCode[9] = 6;
      let message = device.bridge_device.internet_token;

      // ترکیب رشته و بافر
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.bridge_device.id].publish(
        device.bridge_device.serial + "/sys",
        combinedMessage,
      );
    } else {
      if (!clients[device.id]) return;
      const decimalArray = [6, 6];
      const asciiArray = decimalArray.map((num) => String.fromCharCode(num));
      clients[device.id].publish(
        device.serial + "/sys",
        device.internet_token + asciiArray.join(""),
      );
    }
  };

  return (
    // Modal
    !checkCode ? (
      <div
        className="modal fade"
        id="learnCodeModal"
        tabIndex="-1"
        aria-labelledby="learnCodeLable"
        aria-hidden="true"
        ref={modalName}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="learnCodeLable">
                یادگیری
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
                onClick={() => setLearningMode(false)}
              ></button>
            </div>
            <div className="modal-body">
              {learningMode == false ? (
                wirelessKeyMode ? (
                  <p>
                    سوئیچ را مطابق راهنمای مربوطه در وضعیت یادگیری قرار دهید و
                    گزینه یادگیری را انتخاب کنید
                  </p>
                ) : (
                  <p>
                    پس از زدن دکمه یادگیری، ریموت را مقابل دستگاه نگه دارید و
                    دکمه مورد نظر را بفشارید
                  </p>
                )
              ) : learningMode == true ? (
                wirelessKeyMode ? (
                  <p>
                    سوئیچ را مطابق راهنمای مربوطه در وضعیت یادگیری قرار دهید و
                    گزینه یادگیری را انتخاب کنید
                  </p>
                ) : (
                  <p>لطفا دکمه ریموت را بفشارید</p>
                )
              ) : null}
            </div>
            <div className="modal-footer">
              {learningMode == true && !wirelessKeyMode ? (
                <button
                  type="button"
                  className="btn btn-outline-success-app"
                  onClick={() => {
                    handleCancleLearnCode();
                    setLearningMode(false);
                  }}
                >
                  انصراف
                </button>
              ) : null}

              {!learningMode ? (
                <button
                  type="button"
                  className="btn btn-success-app"
                  onClick={(e) => setLearningMode(true)}
                >
                  یادگیری
                </button>
              ) : lazyLoadForWirlessLearnCode && wirelessKeyMode ? (
                <button
                  className="btn btn-success-app"
                  type="button"
                  disabled=""
                >
                  <span
                    className="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {/* <span className="visually-hidden"></span> */}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div
        className="modal fade"
        id="learnCodeModal"
        tabIndex="-1"
        aria-labelledby="learnCodeLable"
        aria-hidden="true"
        ref={modalName}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="learnCodeLable">
                یادگیری
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
                onClick={() => setLearningMode(false)}
              ></button>
            </div>
            <div className="modal-body">
              <p>ایا یادگیری به درستی انجام شد؟</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-success-app mb-2"
                onClick={() => {
                  handleSubmitLearnCodeInWirelessMode();
                }}
              >
                تایید
              </button>
              {/* <button
                type="button"
                className="btn btn-outline-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                انصراف
              </button> */}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default LearnCodeModal;
